import {Identity, PeerId, Restrictions} from './common.js';
import {Immutable} from 'immer';
import {DomainKeys, Options} from './state.js';

export const contextDomain = DomainKeys.Context;
export type ContextId = string;
export type Lifetime = 'ref-counted' | 'ownership' | 'retained' | 'activity';
export type Version = Immutable<{ updates: number, timestamp: number }>;
export type ContextData = Immutable<{ [name: string]: unknown }>
export type Context = Immutable<{
    id: ContextId,
    lifetime: Lifetime,
    members: Set<PeerId>
    creator: PeerId
    identity: Identity
    name?: string
    read_permissions?: Restrictions
    write_permissions?: Restrictions
    data?: ContextData
    owner?: PeerId
    version?: Version
    local?: boolean
    options?: Options
}>

export type ContextDomain = {
    restrictions: Restrictions
}
